import axiosInstance from "api/axiosInstance";
import API from "api/endpoints";

export const fetchDepartments = async () => {
  try {
    const response = await axiosInstance.get(API.department.getList);
    return response.data || [];
  } catch (error) {
    console.error("Error fetching departments:", error);
    return [];
  }
};

export const fetchEmployees = async (departmentId) => {
  try {
    const response = await axiosInstance.get(API.performanceReview.getLatestReviews(departmentId));

    if (response.data && Array.isArray(response.data)) {
      // Filter by role and department
      const employeeList = response.data;
      return employeeList;
    } else {
      console.error("Invalid response format");
      return [];
    }
  } catch (error) {
    console.error("Error fetching employees:", error);
    throw error;
  }
};


